<main class="details-container container mt-5 mb-5" style="padding: 1rem">
   <div class="row g-4 justify-content-center">
      <!-- Left Sidebar -->
      <div class="col-12 col-md-3">
         <div class="card-container">
            <!-- Logo -->
            <div class="logo">
               <ng-container *ngIf="newDataStorage?.logo; else showInitial">
                  <img
                     [src]="newDataStorage.logo"
                     [alt]="newDataStorage.name"
                     (error)="handleImageError($event)"
                  />
               </ng-container>
               <ng-template #showInitial>
                  <span class="initial">
                     {{
                        newDataStorage?.name
                           ? newDataStorage.name.charAt(0)
                           : "?"
                     }}
                  </span>
               </ng-template>
            </div>

            <!-- Content -->
            <div class="content">
               <!-- Name and Watchlist button -->
               <div class="top-row">
                  <div
                     class="company-name"
                     title="{{ newDataStorage?.name || 'N/A' }}"
                  >
                     {{ newDataStorage?.name || "N/A" }}
                  </div>
                  <!-- <div class="watchlist-btn">
                     <app-watchlist-button
                        [stock]="newDataStorage"
                     ></app-watchlist-button>
                  </div> -->
               </div>

               <!-- Symbol -->
               <p class="symbol">
                  {{ newDataStorage?.company_symbol || "N/A" }}
               </p>

               <!-- Price -->
               <!-- <p class="price">
                  {{
                     newDataStorage?.ipo_status === "Priced"
                        ? formatPriceWithSymbol(
                             newDataStorage?.ipo_priced_price,
                             newDataStorage?.country
                          )
                        : formatPriceRangeWithSymbol(
                             newDataStorage?.ipo_price,
                             newDataStorage?.country
                          )
                  }}
               </p> -->
            </div>
         </div>

         <!-- <app-shariah-compliance
        [ticker]="newDataStorage.company_symbol"
        [disclaimer]="newDataStorage.disclaimer"
        [updatedDate]="formattedUpdateDate"
        [compliance]="newDataStorage.sharia_compliance"
        [rating]="newDataStorage.ranking_v2"
        (viewDetailedReportClicked)="onDetailedReportClicked()"
        [reportTypeSection]="reportTypeSection"
        [reportTypeYear]="reportTypeYear">
      </app-shariah-compliance> -->
         <!-- <app-details-header
                  [item]="stock?.companyProfile"
                  [logoUrl]="stock?.companyProfile?.logo"
                  [stockName]="stock?.companyProfile?.name"
                  [stockTicker]="stock?.companyProfile?.ticker"
                  [currentPrice]="fundamentals?.currentPrice"
                  [currency]="stock?.companyProfile?.currency"
                  [priceChange]="fundamentals?.change"
                  [percentChange]="percentChange"
                  [countryName]="fullCountryName"
                  [sectorName]="stock?.companyProfile?.musaffaSectorName"
                  [marketCap]="stock?.companyProfile?.marketCapClassification"
                  [lastDate]="fundamentals.fullDatetime"
                  [stockExchange]="stock?.companyProfile?.exchange"
                  [isShown]="isShown"
                  [isAddedInWatchlist]="isAddedInWatchlist"
                  [countryCode]="countryName"
                  (openAddLists)="isShown = true"
                  [stockType]="'Stock'"
                  [chartTicker]="chartTicker"
                  [showTradingViewTicker]="showTradingViewChart"
               >
               </app-details-header> -->

         <app-compliance-status-card
            [isIpo]="canView"
            [stockType]="type2"
            [isin]="newDataStorage?.isin"
            [mainTicker]="newDataStorage?.company_symbol"
            [disclaimer]="newDataStorage.disclaimer"
            [complianceStatus]="newDataStorage?.sharia_compliance"
            [complianceRanking]="newDataStorage?.ranking_v2"
            [ticker]="newDataStorage?.ticker"
            [countryCode]="newDataStorage?.country"
            [canViewScreeningReport]="canView"
            [lastUpdate]="formattedUpdateDate"
            [reportDate]="reportDate"
            [reportTypeSection]="reportTypeSection"
            [reportTypeYear]="reportTypeYear"
            (goToComplianceTab)="onDetailedReportClicked()"
            [showShariahTab]="showShariahTab"
            [hideHistory]="hideHistory"
         >
         </app-compliance-status-card>
      </div>

      <!-- Right Main Content -->
      <div class="col-12 col-md-8" style="padding: 0 1rem">
         <div
            style="
               display: flex;
               flex-wrap: wrap;
               justify-content: space-between;
               align-items: center;
               border-bottom: 1px solid #e5e5e5;
            "
         >
            <!-- Tabs -->
            <div style="display: flex; flex-wrap: wrap">
               <button
                  *ngFor="let tab of getTabs(); let i = index"
                  (click)="selectTab(i)"
                  style="
                     background: transparent;
                     border: none;
                     outline: none;
                     cursor: pointer;
                     padding: 1rem 0.5rem 0rem 0;
                     position: relative;
                     font-size: 0.9rem;
                     display: flex;
                     flex-direction: column;
                     align-items: center;
                  "
               >
                  <span
                     style="margin: 0px 10px"
                     [ngStyle]="
                        checkSelectedTab(i)
                           ? {
                                background:
                                   'linear-gradient(90deg, #2AA4BE 0%, #1DAE50 100%)',
                                '-webkit-background-clip': 'text',
                                '-webkit-text-fill-color': 'transparent',
                                'font-weight': '600'
                             }
                           : {
                                color: '#666',
                                'font-weight': '400'
                             }
                     "
                  >
                     {{ tab }}
                  </span>

                  <span
                     *ngIf="checkSelectedTab(i)"
                     style="
                        margin-top: 8px;
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(
                           90deg,
                           #1fb9fc 0%,
                           #2bc071 100%
                        );
                        border-radius: 2px;
                     "
                  >
                  </span>
               </button>
            </div>

            <!-- Share Button -->
            <div style="position: relative; display: inline-block">
               <button
                  (click)="toggleSharePopup()"
                  style="
                     display: flex;
                     align-items: center;
                     gap: 0.3rem;
                     padding: 0.4rem 0.8rem;
                     border: 1px solid #28a745;
                     border-radius: 4px;
                     color: #28a745;
                     background: transparent;
                     font-size: 0.9rem;
                     font-weight: 500;
                     cursor: pointer;
                     margin-top: 0.5rem;
                  "
               >
                  Share
                  <svg
                     style="width: 16px; height: 16px"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="2"
                     viewBox="0 0 24 24"
                  >
                     <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"></path>
                     <polyline points="16 6 12 2 8 6"></polyline>
                     <line x1="12" y1="2" x2="12" y2="15"></line>
                  </svg>
               </button>

               <div
                  *ngIf="isSharePopupVisible"
                  style="
                     position: absolute;
                     top: 110%;
                     right: 0;
                     background: white;
                     border: 1px solid #ddd;
                     border-radius: 5px;
                     padding: 0.5rem;
                     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                     z-index: 1000;
                     min-width: 150px;
                  "
               >
                  <div
                     style="display: flex; flex-direction: column; gap: 0.5rem"
                  >
                     <button
                        (click)="copyLink()"
                        style="
                           background: none;
                           border: none;
                           text-align: left;
                           cursor: pointer;
                           display: flex;
                           align-items: center;
                           gap: 0.5rem;
                        "
                     >
                        <img
                           src="assets/icons/menu/copylink.svg"
                           alt="Copy"
                           width="16"
                           height="16"
                        />
                        Copy Link
                     </button>

                     <a
                        [href]="whatsappShareUrl"
                        target="_blank"
                        style="
                           text-decoration: none;
                           color: inherit;
                           display: flex;
                           align-items: center;
                           gap: 0.5rem;
                        "
                     >
                        <img
                           src="assets/icons/menu/whatsapp.svg"
                           alt="WhatsApp"
                           width="16"
                           height="16"
                        />
                        WhatsApp
                     </a>

                     <a
                        [href]="linkedinShareUrl"
                        target="_blank"
                        style="
                           text-decoration: none;
                           color: inherit;
                           display: flex;
                           align-items: center;
                           gap: 0.5rem;
                        "
                     >
                        <img
                           src="assets/icons/menu/linkedin.svg"
                           alt="LinkedIn"
                           width="16"
                           height="16"
                        />
                        LinkedIn
                     </a>

                     <a
                        [href]="facebookShareUrl"
                        target="_blank"
                        style="
                           text-decoration: none;
                           color: inherit;
                           display: flex;
                           align-items: center;
                           gap: 0.5rem;
                        "
                     >
                        <img
                           src="assets/icons/menu/facebook.svg"
                           alt="Facebook"
                           width="16"
                           height="16"
                        />
                        Facebook
                     </a>
                  </div>
               </div>
            </div>
         </div>

         <div class="tabs-content" style="margin-top: 1rem">
            <!-- Tab Content -->
            <div *ngIf="checkSelectedTab(0)">
               <section style="padding-top: 1rem">
                  <ng-container *ngIf="hasData(newDataStorage)">
                     <app-ipo-details
                        [companyProfile]="newDataStorage"
                     ></app-ipo-details>
                  </ng-container>
               </section>
            </div>
            <div *ngIf="checkSelectedTab(1)">
               <section style="padding-top: 1rem">
                  <ng-container *ngIf="hasData(newDataStorage)">
                     <app-ipo-data-lock *ngIf="!isUserLoggedIn"></app-ipo-data-lock>
                     <app-screener-report
                     *ngIf="isUserLoggedIn"
                        [showShariahTab]="showShariahTab"
                        [storedResponse]="screenerReportResponse"
                        [type]="type"
                        (responseLoaded)="screenerDataLoaded($event)"
                        [companyProfile]="newDataStorage"
                     >
                     </app-screener-report>
                  </ng-container>
               </section>
            </div>

            <div *ngIf="checkSelectedTab(2)">
               <app-stock-profile
                  [profileDescription]="newDataStorage?.description || ''"
                  [sector]="newDataStorage?.sector || ''"
                  [industry]="newDataStorage?.finnhubIndustry || ''"
                  [website]="newDataStorage?.weburl || ''"
                  [phone]="newDataStorage?.phone || ''"
                  [address]="newDataStorage?.address || ''"
               >
               </app-stock-profile>
            </div>
         </div>
      </div>
   </div>
</main>
